import { ServiceConfig } from '../services/config'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { IDocumentModel } from './typings'
import { get } from '../services/crud'

const baseUrl = `${ServiceConfig.baseAPIUrl}/Location`

export const getLocationDocuments = createAsyncThunk<IDocumentModel[], string>(
  'locationDocuments/all',
  async (locationId, thunkApi) => {
    const response = await get(`${baseUrl}/core/${locationId}/documents`)
    if (response.ok) return await response.json()
    return thunkApi.rejectWithValue(await response.json())
  },
)
